import React from "react";
var __jsx = React.createElement;
import { api__getSimilarPosts } from "@/apis/posts/similar";
import { useTranslation } from "@i18n";
import { useEffect } from "react";
import stl from "./SimilarPosts.module.css";
import { useState } from "react";
import useIsMobile from "@hooks/useIsMobile";
import BoxLoading from "@componentsShared/placeholders/BoxLoading/BoxLoading";
import { Link } from "react-router-dom";
import useHelpers from "@hooks/useHelpers";
import { useFullPageData } from "@/common/Contexts/FullPageContext";
import { ModernCard } from "@/components/SearchComponent/ModernCard";
var SimilarPosts = function SimilarPosts(_ref) {
  var postId = _ref.postId;
  var _ref2 = useFullPageData() || {},
    similarPosts = _ref2.similarPosts;
  var _useTranslation = useTranslation(["web_post_view"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl,
    navigateToHard = _useHelpers.navigateToHard;
  var _useState = useState(similarPosts || []),
    similar = _useState[0],
    setSimilar = _useState[1];
  var isMobile = useIsMobile();
  var _useState2 = useState(similar.length === 0),
    loading = _useState2[0],
    setLoading = _useState2[1];
  useEffect(function () {
    (similar === null || similar === void 0 ? void 0 : similar.length) === 0 && postId && api__getSimilarPosts(postId, 5).then(function (data) {
      setSimilar(data);
      setLoading(false);
    });
    return function () {
      return setSimilar([]);
    };
  }, [postId]);
  if (loading) {
    return /*#__PURE__*/React.createElement("div", {
      className: stl.loaderContainer
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(BoxLoading, {
      divHeight: 276,
      numberOfLoaders: 3
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(BoxLoading, {
      divHeight: 48
    })));
  }
  if ((similar === null || similar === void 0 ? void 0 : similar.length) === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: stl.outterContainer,
    id: "similar-posts-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.container
  }, /*#__PURE__*/React.createElement("h2", {
    className: "big",
    id: "similar-posts-title"
  }, t("similar_cars", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.cardContainer,
    id: "similar-posts-cards"
  }, similar.length > 0 && (similar === null || similar === void 0 ? void 0 : similar.map(function (post, i) {
    return i < 4 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModernCard, {
      key: post.id,
      post: post,
      rank: i + 1,
      page: 1,
      referralLocation: "similar",
      sectionType: "similar items",
      isAnchor: true,
      titleTag: "h3"
    }));
  })), isMobile && similar.length > 4 && /*#__PURE__*/React.createElement("button", {
    className: [stl.mobileSimilar].join(" "),
    onClick: function onClick() {
      return navigateToHard("/car/similar-cars/".concat(postId));
    },
    id: "show-more-similar-mobile"
  }, " ", t("show_cars", {
    ns: "web_post_view"
  }))), !isMobile && similar.length > 4 && /*#__PURE__*/React.createElement(Link, {
    className: ["whtBtn", stl.moreSimilar].join(" "),
    to: createUrl("/car/similar-cars/".concat(postId)),
    id: "show-more-similar-desktop"
  }, t("show_cars", {
    ns: "web_post_view"
  }))));
};
export default SimilarPosts;